import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import PropTypes from 'prop-types';

// based upon react-intl's FormattedNumber
function FormattedPercent({ value }) {
  const languageRegionCode = useLanguageRegionCode();
  const formatter = new Intl.NumberFormat(languageRegionCode, { style: 'percent' });
  return formatter.format(value);
}

FormattedPercent.propTypes = {
  value: PropTypes.number.isRequired
};

export default FormattedPercent;
